import { useEffect, useCallback } from "react";
import ApplicationCooLayout from "../../layout/application-coo-layout";
import { TextSubheader } from "../../components/text/text-subheader";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../redux/hook";
import { P2Alert, P2Button } from "react-bootstrap-common-script";
import { Separator } from "../../components/separator";
import { useInitialWindowScrollTo } from "../../hooks/use-initial-window-scroll-to";
import { stageCTrackingId } from "../../utils/wogaa-ids";
import { useWogaa } from "../../hooks/use-wogaa";
import { PolymerAxios } from "../../utils/axios";
import { API_EligibilityDebugLog } from "../../utils/api";

const StageCUnsuccessful = () => {
  const startApplicationFormData = useAppSelector((state) => state.app.ApplicationStartSlice.formData);
  let navigate = useNavigate();
  const applicationId = useAppSelector( (state) => state.app.ApplicationIdSlice.applicationId);
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);

  const continuePayment = useCallback(() => {
    navigate(`/application-coo?application_id=${applicationId}`);
  },[applicationId, navigate])

  useInitialWindowScrollTo();

  // WOGAA tracking for Stage C - auto complete on unsuccessful payment (for analytics purposes)
  useWogaa({
    trackingId: stageCTrackingId,
    autoStart: false,
    autoComplete: true,
    applicationId: applicationId ?? undefined,
    hdbRef: startApplicationFormData.selected_hdb_property?.hdb_ref,
  });

  useEffect(() => {
    if(!applicationId){
      window.location.href = "/transfer/dashboard";
    }
    
    DebugLogging();
  }, [applicationId])

  const DebugLogging = async () => {
    await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
      applicationUuid: loginUser?.uinfin,
      message: `FE STAGE C --- Unsuccessful Payment, application ID:${applicationId}`
    });
  }

  return (
    <ApplicationCooLayout>
      <div style={{ padding: "41px 41px 44px 40px" }}>
        <TextSubheader
          subheaderMain="Stage C: Make Payment"
          subheaderSub={startApplicationFormData.selected_hdb_property?.address}
        />
        <div className="polymer-unsuccess-container">
          <P2Alert withCTA={false} variant="danger" text={`Sorry, the payment cannot be processed now. Please try again later.`} />
        </div>
        <Separator />
        <div className="polymer-unsuccess-button-group polymer-button-wrapper">
          <P2Button variant={"primary-1"} onClick={continuePayment}>
            Retry
          </P2Button>
        </div>
      </div>
    </ApplicationCooLayout>
  );
};
export default StageCUnsuccessful;
